import { BlockNodes, IMenuButton } from '@principle-theorem/editor';
import { type MenuButtonLoaderFn } from '@principle-theorem/ng-prosemirror';
import { Editor } from '@tiptap/core';
import { TextStylingMenuComponent } from './text-styling-menu/text-styling-menu.component';

export function createTextStylingMenuButton(): MenuButtonLoaderFn<
  TextStylingMenuComponent,
  IMenuButton
> {
  return () => ({
    component: TextStylingMenuComponent,
    data: {
      buttonType: 'submenu-detail',
      canActivateFn: (editor: Editor) =>
        editor.isActive(BlockNodes.Heading) ||
        editor.isActive(BlockNodes.Paragraph),
      buttonText: '',
      icon: '',
      tooltip: '',
      command: () => {
        //
      },
    },
  });
}
